import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TabGroup from 'common/tab-group';
import { setTerm, setTermsAndUpdatePowerBookingTimes, } from 'store/search-request/search-request-actions';
import { TabPanel, TabPanels, Box, Icon, Button, Text, Flex } from '@spothero/ui';
import PowerBookingModal from './PowerBookingModal';
import { Calendar as IconCalendar, Clock as IconClock } from '@spothero/icons';
import dayjs from 'utils/dayjs';
import useConfig from 'hooks/use-config';
import FormatUtils from 'utils/format';
import trackPowerBookingOpened from 'segment/events/power-booking-opened';
const styleOverrides = {
    button: {
        fontFamily: 'body',
        padding: '3',
        fontSize: 'base',
        fontWeight: 'normal',
        color: 'gray.600',
        _selected: {
            borderBottom: '2px',
            borderBottomColor: 'primary.default',
            height: 'auto',
            color: 'primary.default',
            fontWeight: 'semibold',
            ':hover': {
                color: 'primary.default',
            },
        },
        ':hover': {
            color: 'gray.700',
        },
    },
};
export const DEFAULT_ITEMS_ARRAY = [
    {
        label: 'Full Month',
        value: 'monthly',
    },
    {
        label: 'Multiple Days',
        value: 'power_booking',
    },
];
const SearchMonthlyPowerBookingToggle = ({ renderDateTimePicker, renderSearchInput, }) => {
    const dispatch = useDispatch();
    const { city: { data: city }, destination: { data: destination }, searchRequest: { powerBooking: isPowerBooking, powerBookingPeriods }, } = useSelector((state) => state);
    const [isPowerBookingModalOpen, setIsPowerBookingModalOpen] = useState(false);
    const { urlDateFormat, standardTimeFormat } = useConfig();
    const activeItemIndex = isPowerBooking ? 1 : 0;
    const updateSearchTerm = searchTerm => dispatch(setTerm({
        term: searchTerm,
        city,
        destination,
    }));
    const updateSearchTermAndPowerBookingTimes = currentPowerBookingPeriods => dispatch(setTermsAndUpdatePowerBookingTimes({
        city,
        destination,
        powerBookingPeriods: currentPowerBookingPeriods,
        powerBookingSource: 'monthly_search',
    }));
    const onChange = event => {
        if (event ===
            DEFAULT_ITEMS_ARRAY.findIndex(item => item.value === 'power_booking')) {
            setIsPowerBookingModalOpen(true);
            trackPowerBookingOpened({ source: 'monthly_search' });
        }
        else {
            updateSearchTerm(DEFAULT_ITEMS_ARRAY[event].value);
        }
    };
    const handleShowPowerBookingResults = currentPowerBookingPeriods => {
        updateSearchTermAndPowerBookingTimes(currentPowerBookingPeriods);
        setIsPowerBookingModalOpen(false);
    };
    const handleModalClose = () => {
        setIsPowerBookingModalOpen(false);
    };
    const selectedDates = powerBookingPeriods?.map(dates => dayjs(dates?.starts).format(urlDateFormat));
    const selectedStartTime = powerBookingPeriods[0]?.starts
        ? dayjs(powerBookingPeriods[0]?.starts).format(standardTimeFormat)
        : '';
    const selectedEndTime = powerBookingPeriods[0]?.ends
        ? dayjs(powerBookingPeriods[0]?.ends).format(standardTimeFormat)
        : '';
    const selectedDatesLength = selectedDates.length;
    const renderPanelElements = () => {
        return (<Box mt="4">
                <div data-testid="SearchMonthlyPowerBookingToggle-search-input">
                    {renderSearchInput()}
                </div>

                <TabPanels data-testid="SearchMonthlyPowerBookingToggle-tab-panels">
                    <TabPanel display={{
                base: 'block',
                desktop: 'flex',
            }} padding="0" data-testid="SearchMonthlyPowerBookingToggle-monthly-tab">
                        {renderDateTimePicker()}
                    </TabPanel>
                    <TabPanel data-testid="SearchMonthlyPowerBookingToggle-multiple-days-tab" paddingY={{ base: '0', desktop: '3' }} paddingX="0">
                        <Flex justify="space-between" align="center">
                            <Box>
                                <Flex align="center">
                                    <Icon as={IconCalendar} fontSize="xs" mr="2" data-testid="SearchMonthlyPowerBookingToggle-calendar-icon"/>
                                    <Text fontSize={{
                base: 'sm',
                tablet: 'base',
                desktop: 'base',
            }} fontWeight="semibold" data-testid="SearchMonthlyPowerBookingToggle-power-booking-dates">{`Dates: ${selectedDatesLength} ${FormatUtils.pluralize(selectedDatesLength, 'Day', 'Days')} selected`}</Text>
                                </Flex>
                                <Flex align="center">
                                    <Icon as={IconClock} fontSize="xs" mr="2" data-testid="SearchMonthlyPowerBookingToggle-clock-icon"/>
                                    <Text fontSize={{
                base: 'sm',
                tablet: 'base',
                desktop: 'base',
            }} fontWeight="semibold" data-testid="SearchMonthlyPowerBookingToggle-power-booking-times">{`Times: ${selectedStartTime} - ${selectedEndTime}`}</Text>
                                </Flex>
                            </Box>
                            <Button variant="secondary" height="35px" width="90px" onClick={() => setIsPowerBookingModalOpen(true)} data-testid="SearchMonthlyPowerBookingToggle-edit-button">
                                <Text fontSize="sm" fontWeight="semibold" color="primary.default">
                                    Change
                                </Text>
                            </Button>
                        </Flex>
                    </TabPanel>
                </TabPanels>
            </Box>);
    };
    return (<>
            <TabGroup items={DEFAULT_ITEMS_ARRAY} onChange={onChange} renderPanels={renderPanelElements} styleOverrides={styleOverrides} tabProps={{ index: activeItemIndex, align: 'center' }} showTabPanels/>
            {isPowerBookingModalOpen && (<PowerBookingModal onModalClose={handleModalClose} onShowResults={handleShowPowerBookingResults} selectedDates={selectedDates} selectedStartTime={selectedStartTime} selectedEndTime={selectedEndTime}/>)}
        </>);
};
export default SearchMonthlyPowerBookingToggle;
